module.exports = __webpack_public_path__ + "static/media/checklist-counterparties.7e761588.pdf";